import { t } from 'ttag';

export const localization = {
  pagination: {
    labelDisplayedRows: t`{from}-{to} з {count}`,
    labelRowsSelect: t`Рядків`,
    labelRowsPerPage: t`Рядків`,
    firstAriaLabel: t`Перша сторінка`,
    firstTooltip: t`Перша сторінка`,
    previousAriaLabel: t`Попередня сторінка`,
    previousTooltip: t`Попередня сторінка`,
    nextAriaLabel: t`Наступна сторінка`,
    nextTooltip: t`Наступна сторінка`,
    lastAriaLabel: t`Остання сторінка`,
    lastTooltip: t`Остання сторінка`,
  },
  toolbar: {
    nRowsSelected: t`{0} вибрано`,
    searchPlaceholder: t`Пошук`,
    searchTooltip: t`Пошук`,
  },
  header: {
    actions: t`Дії`,
  },
  body: {
    emptyDataSourceMessage: t`Не знайдено`,
    filterRow: {
      filterTooltip: t`Фільтр`,
    },
    editRow: {
      deleteText: t`Дійсно видалити цей рядок?`,
      cancelTooltip: t`Відмінити`,
      saveTooltip: t`Зберегти`,
    },
    editTooltip: t`Редагувати`,
    addTooltip: t`Додати`,
    deleteTooltip: t`Видалити`,
  },
};
